import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../api/apiService";
import { API_ENDPOINTS } from "../../../constants/apiEndpoints";

export const getAllMealsAction = createAsyncThunk(
  "meals/getAllMeals",
  async ({ page = 1, limit = 10 } = {}, thunkAPI) => {
    try {
      const response = await apiService.get(
        `${API_ENDPOINTS.MEALS.GET_ALL}?page=${page}&limit=${limit}`
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const getUserMealsAction = createAsyncThunk(
  "meals/getUserMeals",
  async ({ uid, date }, thunkAPI) => {
    try {
      const response = await apiService.get(
        API_ENDPOINTS.MEALS.GET_USER_MEALS(uid, date)
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const getMealByIdAction = createAsyncThunk(
  "meals/getMealById",
  async (mealId, thunkAPI) => {
    try {
      const response = await apiService.get(
        API_ENDPOINTS.MEALS.GET_BY_ID(mealId)
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const createMealAction = createAsyncThunk(
  "meals/createMeal",
  async (mealData, thunkAPI) => {
    try {
      const response = await apiService.post(
        API_ENDPOINTS.MEALS.CREATE,
        mealData
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const updateMealAction = createAsyncThunk(
  "meals/updateMeal",
  async ({ mealId, mealData }, thunkAPI) => {
    try {
      const response = await apiService.put(
        API_ENDPOINTS.MEALS.UPDATE(mealId),
        mealData
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const deleteMealAction = createAsyncThunk(
  "meals/deleteMeal",
  async (mealId, thunkAPI) => {
    try {
      await apiService.delete(API_ENDPOINTS.MEALS.DELETE(mealId));
      return mealId;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
